import 'intersection-observer';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import lazyLoad from '@ichef/fe-lazy-load';

import { initializeI18n } from 'shared/utils/i18n';
import { initSentry } from 'shared/utils/sentry';
import registerPerfEventForGA from 'shared/utils/registerPerfEventForGA';

registerPerfEventForGA();
initSentry();

if (window.localStorage === undefined) {
  window.localStorage = {
    getItem: () => {},
    setItem: () => {},
  };
}

async function injectResizeObserverPolyfill() {
  if ('ResizeObserver' in window === false) {
    const module = await import('@juggle/resize-observer');
    window.ResizeObserver = module.ResizeObserver;
  }
}

async function init() {
  await initializeI18n();
  await injectResizeObserverPolyfill();

  const RootApp = lazyLoad(() => import('./RootApp'));

  const container = document.getElementById('app');
  const root = createRoot(container);

  root.render(
    <Suspense fallback={null}>
      <RootApp />
    </Suspense>,
  );
}

init();
